import { Skeleton } from "primereact/skeleton";
import { ReactElement } from "react";

export const OrderSummaryLoading = (): ReactElement => {
    return (
        <div
            id="quotation-order-summary-loading"
            data-cy="quotation-order-summary-loading"
        >
            <Skeleton shape="rectangle" height="25vh" width="100%" />
        </div>
    );
};
